/**
 * Careers
 */
$(document).on("ready", function () {
  $(".btn.my-interests").on("click", function (e) {
    e.preventDefault();
    if ($("input.iTop3").length) {
      var checkBoxes = $("input.iTop3");
      checkBoxes.prop("checked", !checkBoxes.prop("checked"));
      $(this).closest("form").submit();
    } else {
      addOverlay("my-values", '<h3>Please complete and save your <a href="' + fullBase + '/discover-careers/interest-test/">Interests Quiz</a> first.');
    }
  });

  $(".btn.my-values").on("click", function (e) {
    e.preventDefault();
    if ($("input.vTop3").length) {
      var checkBoxes = $("input.vTop3");
      checkBoxes.prop("checked", !checkBoxes.prop("checked"));
      $(this).closest("form").submit();
    } else {
      addOverlay("my-values", '<h3>Please complete and save your <a href="' + fullBase + '/discover-careers/value-test/">Work Values Quiz</a> first.');
    }
  });

  if ($("#matchme").length) {
    $("#StudyArea").on("change", function () {
      $(this).closest("form").submit();
    });
  }

  // Submit the selected career cluster using mouse or keyboard activation.
$("#categories button.cluster").on("click", function () {
  var $form = $(this).closest("form");

  $form.find('input[name="Cluster"]').val($(this).attr("data-value"));
  $form.submit();
});

  if ($("#theCareer, #my-careers").length) {
    $(".expand").on("click", function (e) {
      e.preventDefault();
      if ($(this).text() == "Show More") {
        var txt = "Show Less";
      } else {
        var txt = "Show More";
      }
      $(this).text(txt).closest("div").toggleClass("showMore");
    });
    $(document).on("ready", function () {
      const $saveBtn = $(".save");
      const url = `/wp-admin/admin-ajax.php`;
      const params = new URLSearchParams(window.location.search);
      const careerid = params.get("careerid");
      if (careerid) {
        const req = $.get(url, {
          action:'fw_fakeSavedCareerCheck',
          CareerID: careerid,
        });

        req.done(function (data) {
          if (data.success) {
            $saveBtn.removeClass("save").removeClass("primary").addClass("remove").addClass("secondary").text("REMOVE");
          }
        });
      }
    });
    $(document).on("click", ".save", function () {
      var $svbtn = $(this);

      const req = $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action:'fw_fakeSaveCareer',
          CareerID: $(this).attr("id"),
        },
        dataType: "json",
      });

      req.done(function (data) {
        if (data[0] === "success") {
          $svbtn.removeClass("save").removeClass("primary").addClass("remove").addClass("secondary").text("REMOVE");
        } else if (data.errors.length > 0) {
          for (var i = 0; i < data.errors.length; i++) {
            $cur.children(".errors").append('<p class="error">' + data.errors[i] + "</p>");
          }
        } else {
          $cur.children(".errors").append('<p class="error">' + data + "</p>");
        }
      });

      req.fail(function (error) {
        console.log(error);
      });
    });
    $(document).on("click", "#theCareer .remove, #my-careers td.remove span", function () {
      var $svbtn = $(this);
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action:'fw_fakeSaveCareer',
          CareerID: $(this).attr("id"),
          remove: true,
        }, // serializes the form's elements.
        dataType: "json",
        success: function (data) {
          if (data[0] === "success") {
            if ($svbtn.hasClass("mycareer")) {
              window.location.reload();
            } else {
              $svbtn.removeClass("remove").removeClass("secondary").addClass("save").addClass("primary").text("SAVE");
            }
            //console.log('remove');
          } else if (data.errors.length > 0) {
            for (var i = 0; i < data.errors.length; i++) {
              $cur.children(".errors").append('<p class="error">' + data.errors[i] + "</p>");
            }
          } else {
            $cur.children(".errors").append('<p class="error">' + data + "</p>");
          }
        },
        error: function () {},
      });
    });
    $(document).on("click", "#my-careers td.favorite span", function (e) {
      var $svbtn=$(this);
			if($(this).children('i').hasClass('fav')){
				var rmv=true;
			}else{
				var rmv=false;
			}
			$.ajax({
				   type: "POST",
				   url: '/wp-admin/admin-ajax.php',
				   data: {action:'fw_fakeUpdateFavCareer', 'CareerID':$(this).attr('id'),'remove':rmv}, // serializes the form's elements.
				   dataType: 'json',
				   success: function(data)
				   {
					   if(data[0]==='success'){
						  window.location.reload();
					   }else if(data.errors.length>0){
						   for(var i=0;i<data.errors.length;i++){
							   //$cur.children('.errors').append('<p class="error">'+data.errors[i]+'</p>');
						   }
					   }else{
						   //$cur.children('.errors').append('<p class="error">'+data+'</p>');
					   }
				   },
				   error: function(){
				   }
			});
      window.location.reload();
    });
    $(".toggleDesc").on("click", function () {
      $(this).closest(".desc").toggleClass("open");
    });
  }
}); //END ON READY
